module.exports = __webpack_public_path__ + "img/legal.eb641803.png";